import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { Button } from 'components/atoms/button';
import { useDeleteConfirmModal } from 'hooks/use-delete-confirm-modal';
import { useTranslation } from 'hooks/use-translation';

const FooterWrapper = styled.div`
  align-items: center;
  display: flex;
  text-align: left;

  > div {
    flex: 1;

    > button {
      padding: 0;
    }
  }
`;

export const ProjectPhaseModalFooter: FC<{
  isEdit: boolean;
  isSaveDisabled: boolean;
  hasPhaseDeleteAccess: boolean;
  isLoading?: boolean;
  onCancel(): void;
  onDelete(): void;
  onSubmit(): void;
}> = ({
  isEdit,
  hasPhaseDeleteAccess,
  isSaveDisabled,
  isLoading,
  onCancel,
  onDelete,
  onSubmit,
}) => {
  const DeleteConfirmation = useDeleteConfirmModal({
    title: useTranslation('projects.phase.delete.confirm.title'),
    content: useTranslation('projects.phase.delete.confirm.text'),
    onOk: () => onDelete(),
  });

  return (
    <FooterWrapper>
      <div>
        {isEdit && hasPhaseDeleteAccess ? (
          <Button type="link" danger onClick={DeleteConfirmation}>
            <FormattedMessage id="projects.phase.delete" />
          </Button>
        ) : null}
      </div>
      <Button type="link" size="small" onClick={onCancel} data-testid="cancel">
        <FormattedMessage id="cancel" />
      </Button>
      <Button
        size="small"
        data-testid="submit"
        onClick={onSubmit}
        disabled={isSaveDisabled}
        type="primary"
        loading={isLoading}
      >
        <FormattedMessage id="save" />
      </Button>
    </FooterWrapper>
  );
};
